import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchBranches = async () => {
  const { data } = await axios.get(`${API}/branches`);
  return data;
};
